import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { abufahd_rev, ahmed, ahmed_rev, ahmed_taha, angela_cert, carla_rev, miniauniversity, rec, sally_cert, tart} from '../../images/images';
import './style/prem.css';
gsap.registerPlugin(ScrollTrigger);

const testimonials = [
    { name: "Mr. Abu Fahd", company: "Tart E-commerce Owner", text: "Their attention to detail and ability to resolve complex design and CMS alignment issues instantly is remarkable. SASKE doesn’t just build platforms; they ensure every micro-detail is optimized to perfection with zero delays.", img:tart },
    { name: "Ms. Angela", company: "Arena Capital", text: "شهادة شكر لتصميم و إدارة كل الخدمات التقنيه لمشروع JGK التابع لشركة Arena Capital متعددة الجنيسات.", img:angela_cert, img2:rec, img_width:"50%", img2_width:"50%"},
    { name: "Ms. Carla", company: "Content Creator at Arena Capital", text: "SASKE’s speed of execution and immediate responsiveness completely redefined our development workflow. They turned around critical project milestones in record time with flawless precision. A highly dependable technical partner for any fast-paced business.", img:carla_rev },
    { name: "أ. أحمد عبدالله", company: "متدرب", text: "نمتلك خبره تفوق التوقعات لذلك نتميز بإجتذاب طلابنا إلينا و حب التعلم معنا لكون التعلم معنا رحله شيقه ممتعه يتعمل فيها الطالب كيف يصبح خبير في إدارة ما يتعلمه و فهم كل ما يتعلق به.", img: ahmed_rev },
    { name: "شهادة شكر و خبره", company: "جامعة المنيا التعليميه", text: "شهادة شكر و خبره مقدمه من قبل جامعة المنيا لما بذلناه من مجهود لتطوير و إعادة هيكلة البنية التحتيه بقسم الجيولوجيا - كلية العوم - جامعة المنيا", img:miniauniversity, img_width: "fit-content"},
    { name: "Ms. Sally Alanzy", company: "Project Manager at Calvo", text: "Working with SASKE was a breath of fresh air. They provided transparent communication, consistent updates, and truly took ownership of the project. We felt supported every step of the way, resulting in a successful launch right on schedule.", img:sally_cert },
    { name: "أ. أحمد عفيفى", company: "مؤسس مركز تعليمى", text: "SASKE delivered a robust custom web application that exceeded our expectations. Their engineering quality and attention to detail were phenomenal. The platform now handles thousands of users seamlessly, a true testament to their scalable backend epertise.", img: ahmed},
    { name: "أ. أحمد طه", company: "مسئول تسويق إلكترونى", text: "Our e-commerce site migration was flawless, and the performance boost was immediate. SASKE's advanced SEO expertise significantly increased our organic traffic and conversion rates. We've seen a measurable ROI thanks to their work.", img:ahmed_taha },
];

const PremiumTestimonials = () => {
    const containerRef = useRef(null);
    useGSAP(() => {
        const cards = gsap.utils.toArray('.testimonial-card');
        
        // إنشاء تايم لاين رئيسي يجمد السكشن بالكامل
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top top+=2%",
                end: `+=${testimonials.length * 1000}`, // مسافة كافية لكل كارت ياخد وقته
                pin: true,
                scrub: 1,
            }
        });

        // تحريك الكروت تتابعياً (ما عدا الكارت الأخير يظل مستقراً)
        cards.forEach((card, index) => {
            if (index < cards.length - 1) {
                tl.to(card, {
                    y: -150,           // يطير لأعلى
                    x: -50,            // يميل قليلاً لليسار
                    rotation: -10,     // زاوية دوران طفيفة صايعة
                    opacity: 0,        // يختفي
                    scale: 0.9,
                    duration: 1,
                }, `+=0.5`); // مسافة أمان بين الكروت
            }
        });

    }, { scope: containerRef });

    return (
        <div id="revs" ref={containerRef} style={{ height: '100vh', background: '#0b0c10', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', textAlign:'center', direction:'rtl' }}>
            
            <h2 style={{ position: 'absolute', top: '5vh', color: '#6366f1', fontFamily: 'sans-serif', letterSpacing: '2px', textDecoration:"underline" }}>ماذا قالوا عن SASKE</h2>
            <h2 style={{ position: 'absolute', top: '10vh', color: '#6366f1', fontFamily: 'sans-serif', letterSpacing: '2px' }}>"استمع مباشرة لمن جربوا التزامنا بالتميز و النتائج الملموسه"</h2>

            <div>
                {testimonials.map((item, index) => (
                    <div 
                        key={index}
                        className="testimonial-card"
                        style={{
                            zIndex: testimonials.length - index, // الكارت الأول يكون في الأعلى دائماً
                        }}
                    >
                        <p style={{direction: item.dir?item.dir : "rtl"}}>
                        "{item.text}"
                    </p>
                    <div className='imag_box'>
                        <img src={item.img} alt=''/>
                        <img src={item.img2} alt=''/>
                    </div>
                    <div>
                    <h4 style={{ color: '#6366f1', margin: '0 0 5px 0'}}>{item.name}</h4>
                    <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>{item.company}</span>
                    </div>
                </div>
                ))}
            </div>
        </div>
    );
};

export default PremiumTestimonials;